// extracted by mini-css-extract-plugin
export var cardWrapper = "ShroomsCardPage-module--card-wrapper--oQItq";
export var firstP = "ShroomsCardPage-module--first-p--vUKGN";
export var image = "ShroomsCardPage-module--image--AEUW6";
export var imageWrapper = "ShroomsCardPage-module--image-wrapper--G4e2O";
export var productCardWrapper = "ShroomsCardPage-module--product-card-wrapper--a2eaY";
export var secondP = "ShroomsCardPage-module--second-p--0v3v-";
export var textWrapper = "ShroomsCardPage-module--text-wrapper--ESULb";